"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelValueUtilityClass = void 0;
var generateUtilityClass_1 = __importDefault(require("@mui/material/generateUtilityClass"));
var generateUtilityClasses_1 = __importDefault(require("@mui/material/generateUtilityClasses"));
function getChannelValueUtilityClass(slot) {
    return (0, generateUtilityClass_1.default)('BluiChannelValue', slot);
}
exports.getChannelValueUtilityClass = getChannelValueUtilityClass;
var channelValueClasses = (0, generateUtilityClasses_1.default)('BluiChannelValue', [
    'root',
    'icon',
    'text',
    'units',
    'value',
]);
exports.default = channelValueClasses;
